module.exports = __webpack_public_path__ + "assets/images/caixa_carta2_1325e3f2f0f43907e143ebe4d4dd337d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page-eight/caixa_carta2.png
// module id = 240
// module chunks = 0